import { IconButton, Tooltip } from '@dixa/lib-shared-habla';

import { createAiAgentCustomerReplyPrompt } from './sidekickDebugButton.utils';
import {
  useAskSidekickToDraft,
  useSidekickAiAgent,
} from './useAskSidekickToDraft';

const LABEL = 'Ask Sidekick to draft a reply';

type SidekickCustomerMessageButtonProps = {
  /**
   * The users that wrote in the conversation, most recent first. The first of
   * them that is an AI agent drafts the reply.
   */
  authorIds: readonly string[];
  /** The id of the conversation the message belongs to. */
  csid: string;
  /** The id of the customer message. */
  messageId: string;
  /** When the message was sent. */
  date?: string;
};

/**
 * Lets the user have Sidekick draft the reply of the conversation's AI agent
 * to a customer message on a chosen version.
 */
export const SidekickCustomerMessageButton = ({
  authorIds,
  csid,
  messageId,
  date,
}: SidekickCustomerMessageButtonProps): JSX.Element | null => {
  const aiAgent = useSidekickAiAgent(authorIds);
  const askToDraft = useAskSidekickToDraft();

  if (!aiAgent) return null;

  const draft = () =>
    askToDraft({
      aiAgentId: aiAgent.id,
      title: 'Draft a reply',
      createPrompt: (version) =>
        createAiAgentCustomerReplyPrompt({
          csid,
          messageId,
          date,
          aiAgentName: aiAgent.name,
          ...version,
        }),
    });

  return (
    <Tooltip wrap="span" content={LABEL}>
      <IconButton
        variant="tertiary"
        icon="mim-sidekick"
        aria-label={LABEL}
        onClick={() => void draft()}
      />
    </Tooltip>
  );
};
